export default function () {
  if (!window.config.showSecureNetworkInfo) return <></>;
  return (
    <div className="text-center mt-10">
      <h1 className="font-bold text-xl">!!!!! WAŻNE !!!!!</h1>
      <p>
        W celu poprawy bezpieczeństwa połączenia sieciowego proponujemy
        połączenie z szyfrowaną siecią
      </p>
      <ul className="m-10 text-xl space-y-4">
        <li>Nazwa: NeoWIFI</li>
        <li>Hasło: UzdorwiskaDKP</li>
      </ul>
      <p>
        Wybranie sieci NeoWIFI zapewnia korzystanie z połączenia szyfrowanego.
      </p>
      <p>
        Przełączenie na sieć NeoWIFI nie powoduje zmian w opłacie, czy podawania
        nowego kodu.
      </p>
      <p>Do dyspozycji kuracjuszy pozostają dwie sieci moj@wifi i NeoWIFI.</p>
      <p className="mb-10">
        Połączenie szyfrowane zwiększa bezpieczeństwo w sieci.
      </p>
      NEOSYSTEM
    </div>
  );
}
